import {
    GET_CONSIGNOR_REQUEST, GET_CONSIGNOR_SUCCESS, GET_CONSIGNOR_FAIL,
    CREATE_CONSIGNOR_REQUEST, CREATE_CONSIGNOR_SUCCESS, CREATE_CONSIGNOR_FAIL,
    UPDATE_CONSIGNOR_REQUEST, UPDATE_CONSIGNOR_SUCCESS, UPDATE_CONSIGNOR_FAIL,
    DELETE_CONSIGNOR_REQUEST, DELETE_CONSIGNOR_SUCCESS, DELETE_CONSIGNOR_FAIL
} from "../types/consignorMasterTypes";


function getConsignorReducer(state = { consignor: [] }, action) {
    switch (action.type) {
        case GET_CONSIGNOR_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_CONSIGNOR_SUCCESS:
            return {
                ...state,
                consignor: action.payload,
                isLoading: false
            }
        case GET_CONSIGNOR_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}


function createConsignorReducer(state = { createConsignor: {} }, action) {
    switch (action.type) {
        case CREATE_CONSIGNOR_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case CREATE_CONSIGNOR_SUCCESS:
            return {
                ...state,
                createConsignor: action.payload,
                isLoading: false
            }
        case CREATE_CONSIGNOR_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function updateConsignorReducer(state = { updateConsignor: {} }, action) {
    switch (action.type) {
        case UPDATE_CONSIGNOR_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case UPDATE_CONSIGNOR_SUCCESS:
            return {
                ...state,
                updateConsignor: action.payload,
                isLoading: false
            }
        case UPDATE_CONSIGNOR_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}

function deleteConsignorReducer(state = { deleteConsignor: {} }, action) {
    switch (action.type) {
        case DELETE_CONSIGNOR_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case DELETE_CONSIGNOR_SUCCESS:
            return {
                ...state,
                deleteConsignor: action.payload,
                isLoading: false
            }
        case DELETE_CONSIGNOR_FAIL:
            return {
                ...state,
                error: action.payload,
                isLoading: false
            }
        default:
            return state;
    }
}




export { getConsignorReducer, createConsignorReducer, updateConsignorReducer, deleteConsignorReducer }